<h1 mat-dialog-title class="title">
  {{'modal.file.property' | transloco}}: <strong>{{ data.itemName }}</strong>
</h1>

<div mat-dialog-content>
  <p *ngIf="data.isFolder" class="subtitle">
    {{'modal.folder.textProperty' | transloco}}  
  </p>
  <p *ngIf="!data.isFolder" class="subtitle">
    {{'modal.file.textProperty' | transloco}}  
  </p>

  <div class="fields">
    <mat-form-field appearance="outline" class="share-level-field">
      <mat-label>Share Level</mat-label>
      <mat-select 
      [(value)]="data.shareLevel" 
      [disabled]="!data.isOwner || data.isSystem">
        <mat-option *ngFor="let option of shareLevelOptions" [value]="option.value">
          {{ option.text | transloco}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="share-level-field">
      <mat-label>Share Level Edit</mat-label>
      <mat-select [(value)]="data.shareLevelEdit" [disabled]="!data.isOwner || data.isSystem">
        <mat-option *ngFor="let option of filteredEditOptions" [value]="option.value">
          {{ option.text |  transloco}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    
  </div>
</div>

<div class="dialog-buttons">
    <button mat-button class="cancel" (click)="onCancel()">{{'recordsManagement.delete.cancel' | transloco}}</button>
    <button mat-button class="confirm" (click)="onConfirm()">{{'recordsManagement.delete.confirm' | transloco}}</button>  
</div>
